export const calculateClosingFee = (homePrice: number): number => {
  if (homePrice <= 150000) {
    return 1750;
  } else if (homePrice <= 200000) {
    return 1850;
  } else if (homePrice <= 250000) {
    return 1900;
  } else if (homePrice <= 300000) {
    return 1950;
  } else if (homePrice <= 400000) {
    return 2000;
  } else if (homePrice <= 500000) {
    return 2050;
  } else {
    // For prices over $500,000, add $50 for each $50,000 increment
    const additionalIncrements = Math.ceil((homePrice - 500000) / 50000);
    return 2050 + (additionalIncrements * 50);
  }
};
